import _ from '@lodash';
import LoadingDialog from 'app/admin/common/LoadingDialog';
import { useDispatch, useSelector } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { Tooltip, Icon, IconButton } from '@material-ui/core';
import { useState } from 'react';
import VizsgaFeladatsorService from '../service/VizsgaFeladatsorService';

function TableToolbarRecalculateButton(props) {
	const dispatch = useDispatch();
	const [disabled, setDisabled] = useState(false);
	const [loading, setLoading] = useState(false);
	const filterList = useSelector(rootState => rootState.vizsgaFeladatsorTable.tableBrowserFilter.filterList);

	const handleClick = () => {
		const vizsgaVizsgasor = filterList.find(item => item.propertyName === 'vizsgaVizsgasor');
		if (!_.isUndefined(vizsgaVizsgasor)) {
			setDisabled(true);
			setLoading(true);
			VizsgaFeladatsorService.recalculateAfterDelete(vizsgaVizsgasor)
				.then(response => {
					setLoading(false);
					if (response.successful) {
						dispatch({ type: 'vizsgaFeladatsorTable/event/setNeedDataReload' });
						dispatch(showMessage({ message: 'Ellenőrzés sikeresen végrehajtva.' }));
					} else {
						const propKeys = Object.keys(response.properties);
						if (propKeys.length > 0) {
							dispatch(showMessage({ message: response.properties[propKeys[0]][0].message }));
						} else {
							dispatch(showMessage({ message: 'Feladatsor nem ellenőrizhető, vagy hiba történt.' }));
						}
					}
					setDisabled(false);
				})
				.catch(() => {
					setLoading(false);
					dispatch(showMessage({ message: 'Feladatsor nem ellenőrizhető, vagy hiba történt.' }));
					setDisabled(false);
				});
		} else {
			dispatch(showMessage({ message: 'Kérem válasszon ki egy vizsgasort a szűrők között.' }));
		}
	};
	return (
		<>
			<Tooltip title="Ellenőrzés">
				<IconButton onClick={() => handleClick()} disabled={disabled}>
					<Icon fontSize="small">network_check</Icon>
				</IconButton>
			</Tooltip>
			{loading && <LoadingDialog content="Ellenőrzés folyamatban" />}
		</>
	);
}

export default TableToolbarRecalculateButton;
